import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { emploiDuTempsApi } from '../api/emploi-du-temps.api'
import type { CreateEmploiDuTempsRequest } from '@/shared/types/emploi-du-temps'

const EDT_KEY = ['emploi-du-temps']

export function useEmploisDuTemps(etudiantId: number | undefined) {
  return useQuery({
    queryKey: [...EDT_KEY, etudiantId],
    queryFn: () => emploiDuTempsApi.getByEtudiantId(etudiantId!),
    enabled: !!etudiantId,
  })
}

export function useCreateEmploiDuTemps() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateEmploiDuTempsRequest) => emploiDuTempsApi.create(data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [...EDT_KEY, variables.etudiantId] })
    },
  })
}

export function useUpdateEmploiDuTemps() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: CreateEmploiDuTempsRequest }) =>
      emploiDuTempsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EDT_KEY })
    },
  })
}

export function useDeleteEmploiDuTemps() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => emploiDuTempsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EDT_KEY })
    },
  })
}
